import { z } from 'zod';
import { RelationalOperatorKey } from '../../../../../utils/apollo/graphqlSchema';

const MIN_VALUE = 0;
const MAX_VALUE = 99;
const PRECISION = 2;

const operandSchema = z
  .number()
  .gte(MIN_VALUE)
  .lte(MAX_VALUE)
  // checking precision on field-level
  .superRefine((value, ctx) => {
    if (!value?.toString()?.includes('.')) {
      return;
    }

    const valid = value.toString().split('.')[1]?.length <= PRECISION;

    if (!valid) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: `Up to ${PRECISION} decimal places allowed`,
        fatal: true,
      });

      return z.NEVER;
    }
  });

const betweenSchema = z.object({
  operator: z.literal(RelationalOperatorKey.Between),
  fromOperand: operandSchema,
  toOperand: operandSchema,
});

const singleValueSchema = z.object({
  operator: z.enum([
    // RelationalOperatorKey.Between -> handled in betweenSchema
    RelationalOperatorKey.Contains,
    RelationalOperatorKey.EndsWith,
    RelationalOperatorKey.Equal,
    RelationalOperatorKey.Exists,
    RelationalOperatorKey.Greaterorequal,
    RelationalOperatorKey.Greaterthan,
    RelationalOperatorKey.IsEmpty,
    RelationalOperatorKey.Lessorequal,
    RelationalOperatorKey.Lessthan,
    RelationalOperatorKey.Matches,
    RelationalOperatorKey.Notequal,
    RelationalOperatorKey.NotContains,
    RelationalOperatorKey.NotEndsWith,
    RelationalOperatorKey.NotMatches,
    RelationalOperatorKey.NotStartsWith,
    RelationalOperatorKey.StartsWith,
  ]),
  operand: operandSchema,
});

export const cohortPercentileSchema = z
  .discriminatedUnion('operator', [betweenSchema, singleValueSchema])
  .superRefine((values, ctx) => {
    // Special case for Lessthan operator
    if (
      values.operator === RelationalOperatorKey.Lessthan &&
      values.operand === 0
    ) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Should be more than 0',
        path: ['operand'],
        fatal: true,
      });

      return z.NEVER;
    }

    if (
      values.operator === RelationalOperatorKey.Between &&
      values.fromOperand >= values.toOperand
    ) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: `Should be less than ${values.toOperand}`,
        path: ['fromOperand'],
        fatal: true,
      });

      return z.NEVER;
    }
  });
